export class RegisterInfoFormValues {
  email: string = "";
  firstname: string = "";
  lastname: string = "";
}

